//This component is also used for queued settings

import CheckBox from "components/global/CheckBox";
import styled from "styled-components";
import { capitalizeFirstLetter, getNumArray } from "utils/utils";
import ScheduleDropdown from "./ScheduleDropdown";
import CloseIcon from "icons/CloseIcon";
import PlusIcon from "icons/PlusIcon";

const DayScheduleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;

  &.inactive {
    /* opacity: 0.5; */
  }

  .checkbox_wrapper {
    width: 120px;
    min-width: 120px;
  }

  label {
    margin-left: 8px;
    font-size: 14px;
  }

  .schedule_checkbox {
    height: 16px;
    width: 16px;
  }

  .actionCenter {
    width: 100%;
  }

  .time_col {
    gap: 12px;
  }

  .time_row {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .time_row_dropdown {
    width: 36px;
    height: 36px;
    border: 1px solid red;
  }

  .add_slot_btn {
    margin-top: 8px;
  }
`;

const minuteValues = getNumArray(60).filter((v, i) => i % 5 === 0);

const hours = getNumArray(13)
  .slice(1)
  .map((num) => num);
const minutes = minuteValues.map((num) => (num < 10 ? `0${num}` : `${num}`));

const DaySchedule = ({ day, postScheduleDispatch, postSchedule }) => {
  const schedule = postSchedule.daySchedule?.find(
    (schedule) => schedule.day === day
  );
  const timeSlots = schedule?.slots;

  // add new time slot
  const addNewTimeRow = () => {
    const newArray = [...postSchedule.daySchedule];
    newArray
      .find((item) => item.day === day)
      ["slots"].push({
        hour: "12",
        minute: "00",
        timeOfDay: "PM",
      });
    postScheduleDispatch({ type: "daySchedule", payload: newArray });
  };

  // delete time slot
  const removeField = (index) => {
    const newArray = [...postSchedule.daySchedule];
    const slotArray = timeSlots;
    if (index < 0 || index >= slotArray.length) {
      return;
    }

    slotArray.splice(index, 1);
    newArray.find((item) => item.day === day)["slots"] = slotArray;

    postScheduleDispatch({ type: "daySchedule", payload: newArray });
  };

  const handleChange = (e) => {
    const { value, checked } = e.target;
    // if (checked) {
    //   const updatedData = [...postSchedule.selectedDays, value];
    //   postScheduleDispatch({ type: "selectedDays", payload: updatedData });
    // } else {
    //   const updatedData = postSchedule.selectedDays?.filter(
    //     (item) => item !== value
    //   );
    //   postScheduleDispatch({ type: "selectedDays", payload: updatedData });
    // }
    const newArray = [...postSchedule.daySchedule];
    if (checked) {
      newArray.find((item) => item.day === day)["status"] = true;
      postScheduleDispatch({ type: "daySchedule", payload: newArray });
    } else {
      newArray.find((item) => item.day === day)["status"] = false;
      postScheduleDispatch({ type: "daySchedule", payload: newArray });
    }
  };

  const handleUpdateSlotData = (value, index, fieldName) => {
    const newArray = [...postSchedule.daySchedule];
    let newSlotArray = [...schedule.slots];

    newSlotArray[index][fieldName] = value;
    newArray.find((item) => item.day === day)["slots"] = newSlotArray;

    postScheduleDispatch({ type: "daySchedule", payload: newArray });
  };

  return (
    <DayScheduleWrapper className={schedule?.status === false ? "inactive" : ""}>
      <div className="checkbox_wrapper">
        <CheckBox
          className="schedule_checkbox"
          color="var(--secondary)"
          label={capitalizeFirstLetter(day)}
          id={`${day}`}
          onChange={handleChange}
          value={day}
          defaultChecked={schedule?.status}
        />
      </div>

      <div className="flexRow alignStart alignCenter justifySpaceBetween actionCenter">
        <div className="flexColumn time_col">
          {timeSlots?.map((timeSlot, idx) => {
            return (
              <div className="time_row" key={idx}>
                <ScheduleDropdown
                  value={timeSlot.hour}
                  setValue={(val) => handleUpdateSlotData(val, idx, "hour")}
                  list={hours}
                />
                <span>:</span>
                <ScheduleDropdown
                  value={timeSlot.minute}
                  setValue={(val) => handleUpdateSlotData(val, idx, "minute")}
                  list={minutes}
                />
                <ScheduleDropdown
                  value={timeSlot.timeOfDay}
                  setValue={(val) =>
                    handleUpdateSlotData(val, idx, "timeOfDay")
                  }
                  list={["AM", "PM"]}
                />
                {timeSlots.length > 1 && (
                  <button
                    className="flexRow alignCenter justifyCenter"
                    onClick={() => removeField(idx)}
                  >
                    <CloseIcon size="16px" color="var(--grey_8)" />
                  </button>
                )}
              </div>
            );
          })}
        </div>

        <button
          className="flexRow alignCenter justifyCenter add_slot_btn"
          onClick={addNewTimeRow}
        >
          <PlusIcon size="20px" color="var(--body_text)" />
        </button>
      </div>
    </DayScheduleWrapper>
  );
};

export default DaySchedule;
